import React, {
	useState
}
from "react";
import {
	collection,
	getDocs
}
from "firebase/firestore";

import crearActualizarRutaEstudio
from "../funciones/crearActualizarRutaEstudio";

import {
	db
}
from "../firebase/firebaseConfig";

import {
	useEffect
}
from "react";

import {
	doc,
	updateDoc
}
from "firebase/firestore";

import {
	useNavigate
}
from "react-router-dom";

import {
	useAuth
}
from "../contextos/AuthContext";

const Onboarding = () => {

	const [
        paso,
        setPaso
    ] = useState(0);

	const [
		examenes,
		setExamenes
	] = useState([]);

	const [
		examenSeleccionado,
		setExamenSeleccionado
	] = useState(null);

	const [
		idiomaSeleccionado,
		setIdiomaSeleccionado
	] = useState(null);

	const [
		fechaNacimiento,
		setFechaNacimiento
	] = useState("");

	const [
		nick,
		setNick
	] = useState("");
	
	const [
		perfilActivo,
		setPerfilActivo
	] = useState("estudiante");

	const [
		aceptaDatos,
		setAceptaDatos
	] = useState(false);

	const [
		planSeleccionado,
		setPlanSeleccionado
	] = useState("Basico");

	const [
		fechaObjetivo,
		setFechaObjetivo
	] = useState("");
	
	const [
		horasSemana,
		setHorasSemana
	] = useState(10);

	const {
		usuario
	} = useAuth();
	
	const navigate =
		useNavigate();

	useEffect(
		() => {
	
			const cargarExamenes =
				async () => {
	
					const snap =
						await getDocs(
							collection(
								db,
								"examenes"
							)
						);
	
					const datos =
						snap.docs.map(
							d => d.data()
						);
	
					setExamenes(
						datos
					);
				};
	
			cargarExamenes();
	
		},
		[]
	);

	return (

		<div
			style={{

				minHeight:
					"100vh",

				display:
					"flex",

				flexDirection:
					"column",

				alignItems:
					"center",

				justifyContent:
					"center",

				background:
					"#0f172a",

				color:
					"white",

				padding:
					"2rem",

				textAlign:
					"center"
			}}
		>

			<div
				style={{

					fontSize:
						"6rem",

					marginBottom:
						"1rem",

					animation:
						"flotar 3s ease-in-out infinite"
				}}
			>
				🦊
			</div>

			{
	paso === 0 && (

		<>

			<h1>

				Hola

			</h1>

			<h2>

				¿Cómo quieres que te llame?

			</h2>

			<p>

				Este nombre será el que utilizará Yuta para hablar contigo durante toda la aventura.

			</p>

			<input

				type="text"

				value={nick}

				onChange={(e)=>
					setNick(
						e.target.value
					)
				}

				maxLength={30}

				placeholder="Ejemplo: Diego, ShadowWolf..."

				style={{

					marginTop:"2rem",

					padding:"1rem",

					borderRadius:"12px",

					border:"none",

					width:"320px",

					textAlign:"center",

					fontSize:"1rem"

				}}

			/>

			<button

				disabled={
					nick.trim()===""
				}

				onClick={()=>
					setPaso(1)
				}

				style={{

					marginTop:"2rem",

					padding:"1rem 2rem",

					border:"none",

					borderRadius:"16px",

					background:
						nick.trim()===""
						?
						"#475569"
						:
						"#38bdf8",

					color:"white",

					fontWeight:"bold",

					cursor:
						nick.trim()===""
						?
						"default"
						:
						"pointer"

				}}

			>

				Continuar

			</button>

		</>

	)

}

{
	paso === 1 && (

		<>

			<h1>

				¿Cómo quieres usar Yutake?

			</h1>

			<p>

				Selecciona el perfil con el que comenzarás.

			</p>

			<div
				style={{

					display:"flex",

					gap:"1rem",

					marginTop:"2rem",

					flexWrap:"wrap",

					justifyContent:"center"

				}}
			>

				<button

					onClick={() => {

						setPerfilActivo(
							"estudiante"
						);

						setPaso(2);

					}}

					style={{

						padding:"1.2rem 2rem",

						borderRadius:"16px",

						border:"none",

						cursor:"pointer"

					}}

				>

					🎓 Soy estudiante

				</button>

				<button

					onClick={() => {

						setPerfilActivo(
							"profesor"
						);

						setPaso(90);

					}}

					style={{

						padding:"1.2rem 2rem",

						borderRadius:"16px",

						border:"none",

						cursor:"pointer"

					}}

				>

					👨‍🏫 Soy profesor

				</button>

			</div>

		</>

	)

}

{
	paso === 2 && (

		<>

			<h1>

				¿Cómo prefieres estudiar?

			</h1>

			<p>

				Estamos construyendo
				soporte para más idiomas.

			</p>

			<div
				style={{

					display:
						"flex",

					gap:
						"1rem",

					marginTop:
						"2rem"
				}}
			>

			<button

			onClick={() =>
				setIdiomaSeleccionado(
					"es"
				)
			}
			>

			Español

			</button>

			<button

			onClick={() =>
				setIdiomaSeleccionado(
					"nativo"
				)
			}
			>

			Lengua nativa
			(Próximamente)

			</button>

			</div>

			{
	idiomaSeleccionado && (

		<button

			onClick={() =>
				setPaso(3)
			}

			style={{

				marginTop:
					"2rem",

				padding:
					"1rem 2rem",

				border:
					"none",

				borderRadius:
					"16px",

				background:
					"#38bdf8",

				color:
					"white",

				fontWeight:
					"bold",

				cursor:
					"pointer"
			}}
		>

			Continuar

		</button>
	)
}

		</>
	)
}

{
	paso === 3 && (

		<>

			<h1>

				¿Cuándo naciste?

			</h1>

			<p>

				Esto nos ayuda
				a personalizar
				tu experiencia.

			</p>

			<input

				type="date"

				value={
					fechaNacimiento
				}

				onChange={
					e =>
					setFechaNacimiento(
						e.target.value
					)
				}

				style={{

					padding:
						"1rem",

					borderRadius:
						"12px",

					border:
						"none",

					marginTop:
						"2rem"
				}}
			/>

			{
				fechaNacimiento && (

					<button

						onClick={() =>
							setPaso(4)
						}

						style={{

							display:
								"block",

							margin:
								"2rem auto",

							padding:
								"1rem 2rem",

							border:
								"none",

							borderRadius:
								"16px",

							background:
								"#38bdf8",

							color:
								"white",

							fontWeight:
								"bold",

							cursor:
								"pointer"
						}}
					>

						Continuar

					</button>
				)
			}

		</>
	)
}

{
	paso === 4 && (

		<>

			<h1>

				Tratamiento
				de datos

			</h1>

			<p
				style={{

					maxWidth:
						"700px"
				}}
			>

				Aquí se mostrará
				el texto legal
				definido por
				el equipo jurídico.

			</p>

			<div
	style={{

		marginTop:
			"2rem"
	}}
>

	<label>

		<input

			type="checkbox"

			checked={
				aceptaDatos
			}

			onChange={
				e =>
				setAceptaDatos(
					e.target.checked
				)
			}
		/>

		{" "}
		Acepto el
		tratamiento
		de datos.

	</label>

</div>

{
	aceptaDatos && (

		<button

			onClick={() =>
				setPaso(5)
			}

			style={{

				marginTop:
					"2rem",

				padding:
					"1rem 2rem",

				border:
					"none",

				borderRadius:
					"16px",

				background:
					"#38bdf8",

				color:
					"white",

				fontWeight:
					"bold",

				cursor:
					"pointer"
			}}
		>

			Continuar

		</button>
	)
}

		</>
	)
}

{
	paso === 5 && (

		<>

			<h1>

				Tu plan inicial

			</h1>

			<p>

				Puedes comenzar
				gratis y mejorar
				después si lo deseas.

			</p>

			<div
				style={{

					display:
						"flex",

					gap:
						"1rem",

					marginTop:
						"2rem",

					flexWrap:
						"wrap",

					justifyContent:
						"center"
				}}
			>

				<div
					style={{

						padding:
							"2rem",

						border:
							"2px solid #38bdf8",

						borderRadius:
							"16px",

						maxWidth:
							"280px"
					}}
				>

					<h2>

						Explorador

					</h2>

					<p>

						Comienza gratis.

					</p>

					<button

					onClick={() => {

						setPlanSeleccionado(
							"Basico"
						);

						setPaso(6);
					}}
					>

						Continuar

					</button>

				</div>

				<div
					style={{

						padding:
							"2rem",

						border:
							"2px solid gold",

						borderRadius:
							"16px",

						maxWidth:
							"280px"
					}}
				>

					<h2>

						Yutake+

					</h2>

					<p>

						Acceso completo.

					</p>

					<button>

						Próximamente

					</button>

				</div>

			</div>

		</>
	)
}

{
	paso === 6 && (

		<>

			<h1>

				🎯 ¿Qué examen deseas preparar?

			</h1>

			<p>

				Selecciona el objetivo principal de tu entrenamiento.

			</p>

			<div
				style={{

					display:"flex",

					flexDirection:"column",

					gap:"1rem",

					marginTop:"2rem",

					width:"320px"

				}}
			>

				{
					examenes.map(
						examen => (

							<button

								key={examen.ID}

								onClick={() => {

									setExamenSeleccionado(
										examen
									);

									setPaso(7);

								}}

								style={{

									padding:"1rem",

									border:"none",

									borderRadius:"16px",

									cursor:"pointer"

								}}

							>

								{examen.Examen}

							</button>

						)
					)
				}

			</div>

		</>

	)

}

{
	paso === 7 && (

		<>

			<h1>

				📅 Fecha objetivo

			</h1>

			<p>

				¿Cuándo planeas presentar este examen?

			</p>

			<input

				type="date"

				value={
					fechaObjetivo
				}

				onChange={
					e =>
					setFechaObjetivo(
						e.target.value
					)
				}

				style={{
					padding: "1rem",
					borderRadius: "12px",
					border: "none",
					marginTop: "2rem"
				}}
			/>

			<h2
				style={{
					marginTop: "2rem"
				}}
			>

				⏰ Horas por semana

			</h2>

			<select

				value={
					horasSemana
				}

				onChange={
					e =>
					setHorasSemana(
						Number(
							e.target.value
						)
					)
				}

				style={{
					padding: "1rem",
					borderRadius: "12px"
				}}
			>

				<option value={5}>
					3-5 horas
				</option>

				<option value={10}>
					5-10 horas
				</option>

				<option value={15}>
					10-15 horas
				</option>

				<option value={20}>
					15-20 horas
				</option>

				<option value={30}>
					20+ horas
				</option>

			</select>

			{
				fechaObjetivo && (

					<button

					onClick={() =>
						setPaso(8)
					}

						style={{

							marginTop: "2rem",

							padding:
								"1rem 2rem",

							border: "none",

							borderRadius:
								"16px",

							background:
								"#38bdf8",

							color:
								"white",

							fontWeight:
								"bold",

							cursor:
								"pointer"
						}}
					>

						Continuar

					</button>
				)
			}

		</>
	)
}

{
	paso === 90 && (

		<>

			<h1>

				👨‍🏫 Bienvenido profesor

			</h1>

			<p>

				Estamos preparando todas las herramientas para profesores.

			</p>

			<p>

				Por ahora podrás ingresar al módulo docente.

			</p>

			<button

				onClick={async () => {

					const ref =
						doc(
							db,
							"usuarios",
							usuario.uid
						);

					await updateDoc(

						ref,

						{

							nick,
						
							perfilActivo,
						
							fechaNacimiento,
						
							idiomaPreferido:
								idiomaSeleccionado,
						
							fechaCreacionPerfil:
								new Date().toISOString(),
						
							onboardingCompleto:
								true
						
						}

					);

					navigate("/");

				}}

				style={{

					marginTop:"2rem",

					padding:"1rem 2rem",

					border:"none",

					borderRadius:"16px",

					background:"#38bdf8",

					color:"white",

					fontWeight:"bold",

					cursor:"pointer"

				}}

			>

				Entrar

			</button>

		</>

	)

}

{
	paso === 8 && (

		<>

			<h1>

				🚀 Todo listo

			</h1>

			<p>

				Tu aventura está lista.

			</p>

			<p>

				Examen:
				{" "}
				{
					examenSeleccionado?.Examen
				}

			</p>

			<p>

				Horas semanales:
				{" "}
				{horasSemana}

			</p>

			<p>

				Fecha objetivo:
				{" "}
				{fechaObjetivo}

			</p>

			<button

				onClick={async () => {

					const ref =
						doc(
							db,
							"usuarios",
							usuario.uid
						);

					await updateDoc(
						ref,
						{

							examenPrincipal:
								examenSeleccionado.ID,
						
							examenNombre:
								examenSeleccionado.Examen,
						
							idiomaPreferido:
								idiomaSeleccionado,
						
							fechaNacimiento,
						
							nick,
						
							perfilActivo,
						
							horasSemana,
						
							fechaObjetivo,
						
							fechaCreacionPerfil:
								new Date().toISOString(),
						
							onboardingCompleto:
								true
						
						}
					);

					await crearActualizarRutaEstudio({

						userId:
							usuario.uid,

						examenObjetivo:
							examenSeleccionado.Examen,

						fechaObjetivo,

						horasSemana
					});

					navigate(
						"/"
					);
				}}

				style={{

					marginTop:
						"2rem",

					padding:
						"1rem 2rem",

					border:
						"none",

					borderRadius:
						"16px",

					background:
						"#38bdf8",

					color:
						"white",

					fontWeight:
						"bold",

					cursor:
						"pointer"
				}}
			>

				Comenzar aventura

				

			</button>

		</>
	)
}

		</div>
	);
};

export default Onboarding;